import React, { useState, useEffect } from 'react';
import { Card, Badge, PageHeader } from '../../components/ui';
import api from '../../services/api';

const ACTION_COLOR = {
  login:'info', client_created:'success', client_updated:'info', client_deleted:'danger',
  client_blocked:'warning', client_unblocked:'success', client_recovered:'success',
  password_reset:'warning', password_reset_requested:'warning', plan_updated:'info',
};

const ACTION_ICON = {
  login:'🔐', client_created:'✅', client_updated:'✏️', client_deleted:'🗑️',
  client_blocked:'🚫', client_unblocked:'🔓', client_recovered:'🔄',
  password_reset:'🔑', password_reset_requested:'📧', plan_updated:'📦',
};

export default function ActivityLogs() {
  const [logs, setLogs]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter]  = useState('');

  useEffect(() => { fetchLogs(); }, []);

  const fetchLogs = async () => {
    try { const r = await api.get('/superadmin/activity'); setLogs(r.data.logs || []); }
    catch {} finally { setLoading(false); }
  };

  const filtered = filter ? logs.filter(l => l.action?.includes(filter) || l.details?.toLowerCase().includes(filter.toLowerCase())) : logs;

  // Group by date
  const grouped = filtered.reduce((acc, log) => {
    const date = new Date(log.createdAt).toLocaleDateString('en-GB', { day:'2-digit', month:'short', year:'numeric' });
    if (!acc[date]) acc[date] = [];
    acc[date].push(log);
    return acc;
  }, {});

  return (
    <div>
      <PageHeader title="Activity Logs" subtitle={`${logs.length} total actions recorded`} />

      <div style={{ marginBottom: 20 }}>
        <input value={filter} onChange={e => setFilter(e.target.value)} placeholder="🔍 Filter by action or details..."
          style={{ width: '100%', padding: '10px 14px', background: '#111', border: '1px solid rgba(46,204,113,0.15)', borderRadius: 10, color: '#fff', fontSize: 13, outline: 'none' }} />
      </div>

      {/* Quick filter chips */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        {['','login','client_created','client_deleted','password_reset','plan_updated'].map(a => (
          <button key={a} onClick={() => setFilter(a)} style={{ padding: '5px 14px', borderRadius: 20, border: `1px solid ${filter===a ? '#2ECC71' : 'rgba(46,204,113,0.15)'}`, background: filter===a ? 'rgba(46,204,113,0.12)' : 'transparent', color: filter===a ? '#2ECC71' : '#555', fontSize: 12, cursor: 'pointer', fontWeight: filter===a ? 700 : 400 }}>
            {ACTION_ICON[a] || '📋'} {a || 'All'}
          </button>
        ))}
      </div>

      {loading ? <div style={{ color:'#555', textAlign:'center', padding:40 }}>Loading...</div> : (
        filtered.length === 0 ? (
          <Card style={{ textAlign:'center', padding:60 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>📋</div>
            <h3 style={{ color:'#ccc' }}>No logs found</h3>
          </Card>
        ) : (
          Object.entries(grouped).map(([date, dayLogs]) => (
            <div key={date} style={{ marginBottom: 24 }}>
              <div style={{ fontSize: 12, fontWeight: 800, color: '#2ECC71', textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: 10, paddingLeft: 4 }}>{date}</div>
              <Card style={{ padding: 0, overflow: 'hidden' }}>
                {dayLogs.map((log, i) => (
                  <div key={log.id} style={{ display: 'flex', alignItems: 'flex-start', gap: 14, padding: '14px 18px', borderBottom: i < dayLogs.length - 1 ? '1px solid rgba(255,255,255,0.03)' : 'none', transition: 'background 0.15s' }}
                    onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.02)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    {/* Icon */}
                    <div style={{ width: 34, height: 34, borderRadius: 10, background: 'rgba(46,204,113,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, flexShrink: 0 }}>
                      {ACTION_ICON[log.action] || '📋'}
                    </div>
                    {/* Content */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3, flexWrap: 'wrap' }}>
                        <Badge color={ACTION_COLOR[log.action] || 'gray'}>{log.action?.replace(/_/g,' ')}</Badge>
                        {log.ip && <span style={{ fontSize: 11, color: '#444' }}>{log.ip}</span>}
                      </div>
                      <div style={{ fontSize: 13, color: '#888', lineHeight: 1.5 }}>{log.details || '—'}</div>
                    </div>
                    {/* Time */}
                    <div style={{ fontSize: 11, color: '#444', flexShrink: 0, paddingTop: 2 }}>
                      {log.createdAt ? new Date(log.createdAt).toLocaleTimeString([], { hour:'2-digit', minute:'2-digit' }) : ''}
                    </div>
                  </div>
                ))}
              </Card>
            </div>
          ))
        )
      )}
    </div>
  );
}
